<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="3.25" stroke="currentColor" stroke-width="1.6"/>
<path d="M12 18.25C7.32 18.25 3.37 15.62 1.81 12 3.37 8.38 7.32 5.75 12 5.75c4.68 0 8.63 2.63 10.19 6.25-1.56 3.62-5.51 6.25-10.19 6.25Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
